import Vue from 'vue'

export const HeaderGral = () => {
  const token = Vue.$cookies.get('token_cred')
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
  return headers
}

export const HeaderPdf = () => {
  const token = Vue.$cookies.get('token_cred')
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
      responseType: 'blob'
    }
  }
  return headers
}
